import { of } from 'rxjs';

import { AuthService } from '../services/auth.service';

export const mockedAuthService: AuthService = {
  hasFeatureEnabled: () => of(true),
  hasPermissionOn: () => of(true),
  shouldRefresh: () => of(true),
};
